/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
import {toAbsoluteUrl} from '../../../helpers'
import {
  getListSellingNotification,
  updateSellingNotification,
} from '../../../../app/modules/auth/apis'
import {RedirectPageNoti, useLocalStorage} from '../../../../app/utils'
import useOnScreen from '../../../../app/utils/useOnScreen'
import {Skeleton} from '@mui/material'
import moment from 'moment'
import * as component from '../../../../app/components/redux/componentRedux'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import clsx from 'clsx'

interface NotiContent {
  content: string
  isRead: boolean
  time: string
  contractId: string
  productCode: string
  id: string
}

interface ListNotiContent extends Array<NotiContent> {}

interface INoti {
  totalNoti: number | null
  totalNotiUnread: number | null
  data: ListNotiContent
}

const HeaderNotificationsMenu: FC = () => {
  const [userRoot] = useLocalStorage<any>('persist:root', [])
  const [showSkeleton, setShowSkeleton] = useState(true)
  const [currentStep, setCurrentStep] = useState(1)
  const [dataNoti, setDataNoti] = useState<INoti>({
    totalNoti: null,
    totalNotiUnread: null,
    data: [],
  })
  const ref = useRef<HTMLDivElement>(null)
  const isVisible = useOnScreen(ref)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleCheckNoti = async (id: string, contractId: string, productCode: string) => {
    dispatch(component.actions.showBackdrop({show: true}))
    try {
      await updateSellingNotification(id)
      dispatch(component.actions.showBackdrop({show: false}))
      let btnNoti = document.getElementById('btn-show-noti')
      let menuNoti = document.getElementById('menu-noti')
      RedirectPageNoti(contractId, productCode, history)
      btnNoti?.classList.remove('show')
      btnNoti?.classList.remove('menu-dropdown')
      menuNoti?.classList.remove('show')
    } catch (error: any) {
      dispatch(component.actions.showBackdrop({show: false}))
    }
  }

  const handleGetListNoti = (unRead: boolean) => {
    setCurrentStep(unRead ? 2 : 1)
    getListSellingNotification(userRoot?.userId?.replaceAll('"', ''), unRead)
      .then((res: any) => {
        if (res && !res.isError) {
          let current = moment(new Date())
          res.data.items.forEach((elem: any) => {
            elem.contractId = elem.extrafieldId2
            elem.productCode = elem.extrafieldId3
            let dateSend = moment(elem.sendingTime)
            let checkYear = current.diff(dateSend, 'years')
            if (checkYear > 0) {
              elem.time = checkYear + ' năm trước'
              return
            }
            let checkMonth = current.diff(dateSend, 'months')
            if (checkMonth > 0) {
              elem.time = checkMonth + ' tháng trước'
              return
            }
            let checkWeek = current.diff(dateSend, 'weeks')
            if (checkWeek > 0) {
              elem.time = checkWeek + ' tuần trước'
              return
            }
            let checkDay = current.diff(dateSend, 'days')
            if (checkDay > 0) {
              elem.time = checkDay + ' ngày trước'
              return
            }
            let checkHour = current.diff(dateSend, 'hours')
            if (checkHour > 0) {
              elem.time = checkHour + ' giờ trước'
              return
            }
            let checkMinute = current.diff(dateSend, 'minutes')
            if (checkMinute > 5) {
              elem.time = checkMinute + ' phút trước'
            } else {
              elem.time = ' Mới'
            }
          })
          setDataNoti((preState) => {
            return {...preState, totalNoti: res.data.totalItems, data: res.data.items}
          })
          setTimeout(() => {
            setShowSkeleton(false)
          }, 200)
        }
      })
      .catch((error) => {
        return
      })
  }

  useEffect(() => {
    if (isVisible) {
      setShowSkeleton(true)
      handleGetListNoti(currentStep === 1 ? false : true)
    }
  }, [isVisible])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
      id='menu-noti'
      ref={ref}
    >
      <div
        className='d-flex flex-column bgi-no-repeat rounded-top'
        style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
      >
        <h3 className='text-white fw-bold px-9 mt-10 mb-6'>
          Thông báo <span className='fs-8 opacity-75 ps-3'>{dataNoti.totalNoti}</span>
        </h3>

        <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
          <li className='nav-item'>
            <a
              className={clsx('nav-link text-white opacity-75 opacity-state-100 pb-4', {
                active: currentStep === 1,
              })}
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_1'
              onClick={() => handleGetListNoti(false)}
            >
              Tất cả
            </a>
          </li>

          <li className='nav-item'>
            <a
              className={clsx('nav-link text-white opacity-75 opacity-state-100 pb-4', {
                active: currentStep === 2,
              })}
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_2'
              onClick={() => handleGetListNoti(true)}
            >
              Chưa đọc
            </a>
          </li>

          {/* <li className='nav-item'>
            <a
              className='nav-link text-white opacity-75 opacity-state-100 pb-4'
              data-bs-toggle='tab'
              href='#kt_topbar_notifications_3'
            >
              Logs
            </a>
          </li> */}
        </ul>
      </div>
      {showSkeleton ? (
        <>
          <div className='notification-skeleton-wrap'>
            <div className='notification-skeleton'>
              <Skeleton variant='circular' width={35} height={35} />
              <Skeleton variant='rectangular' width={210} height={60} />
            </div>
            <Skeleton variant='text' width={60} height={30} />
          </div>
          <div className='notification-skeleton-wrap'>
            <div className='notification-skeleton'>
              <Skeleton variant='circular' width={35} height={35} />
              <Skeleton variant='rectangular' width={210} height={60} />
            </div>
            <Skeleton variant='text' width={60} height={30} />
          </div>
          <div className='notification-skeleton-wrap'>
            <div className='notification-skeleton'>
              <Skeleton variant='circular' width={35} height={35} />
              <Skeleton variant='rectangular' width={210} height={60} />
            </div>
            <Skeleton variant='text' width={60} height={30} />
          </div>
          <div className='notification-skeleton-wrap'>
            <div className='notification-skeleton'>
              <Skeleton variant='circular' width={35} height={35} />
              <Skeleton variant='rectangular' width={210} height={60} />
            </div>
            <Skeleton variant='text' width={60} height={30} />
          </div>
        </>
      ) : (
        <>
          <div className='tab-content'>
            <div
              // className='tab-pane fade show active'
              className={clsx('tab-pane fade', {
                active: currentStep === 1,
                show: currentStep === 1,
              })}
              id='kt_topbar_notifications_1'
              role='tabpanel'
            >
              <div className='scroll-y mh-325px my-5 px-6'>
                {dataNoti.data.map((o, index) => (
                  <div
                    key={`alert${index}`}
                    className='d-flex flex-stack py-4 noti-content'
                    onClick={() => handleCheckNoti(o.id, o.contractId, o.productCode)}
                  >
                    <div className='d-flex align-items-center'>
                      {!o.isRead && (
                        <div className='noti-content-unread-symbol symbol symbol-35px me-4' />
                      )}
                      <div className='mb-0 me-2'>
                        {/* <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {o.content}
                        </a> */}
                        <div className='text-gray-700 fs-7 mw-200px'>{o.content}</div>
                      </div>
                    </div>

                    <span className='badge badge-light fs-8'>{o.time}</span>
                  </div>
                ))}

                {dataNoti.data.length === 0 && (
                  <div style={{textAlign: 'center', padding: '28px'}}>
                    {/* <SearchOffIcon style={{width: 80, height: 80, color: '#1f8ce9'}} /> */}
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/illustrations/sketchy-1/no-results.png')}
                    />
                    <p style={{fontSize: '20px', marginTop: '20px'}}>
                      Chưa có thông báo nào cho bạn
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div
              // className='tab-pane fade'
              className={clsx('tab-pane fade', {
                active: currentStep === 2,
                show: currentStep === 2,
              })}
              id='kt_topbar_notifications_2'
              role='tabpanel'
            >
              <div className='scroll-y mh-325px my-5 px-6'>
                {dataNoti.data.map((o, index) => (
                  <div
                    key={`alert${index}`}
                    className='d-flex flex-stack py-4 noti-content'
                    onClick={() => handleCheckNoti(o.id, o.contractId, o.productCode)}
                  >
                    <div className='d-flex align-items-center'>
                      {!o.isRead && (
                        <div className='noti-content-unread-symbol symbol symbol-35px me-4' />
                      )}
                      <div className='mb-0 me-2'>
                        {/* <a href='#' className='fs-6 text-gray-800 text-hover-primary fw-bolder'>
                          {o.content}
                        </a> */}
                        <div className='text-gray-700 fs-7 mw-200px'>{o.content}</div>
                      </div>
                    </div>

                    <span className='badge badge-light fs-8'>{o.time}</span>
                  </div>
                ))}

                {dataNoti.data.length === 0 && (
                  <div style={{textAlign: 'center', padding: '28px'}}>
                    {/* <SearchOffIcon style={{width: 80, height: 80, color: '#1f8ce9'}} /> */}
                    <img
                      alt='Logo'
                      src={toAbsoluteUrl('/media/illustrations/sketchy-1/no-results.png')}
                    />
                    <p style={{fontSize: '20px', marginTop: '20px'}}>
                      Chưa có thông báo nào cho bạn
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* <div className='tab-pane fade' id='kt_topbar_notifications_3' role='tabpanel'>
              <div className='scroll-y mh-325px my-5 px-8'>
                {defaultLogs.map((log, index) => (
                  <div key={`log${index}`} className='d-flex flex-stack py-4'>
                    <div className='d-flex align-items-center me-2'>
                      <span className={clsx('w-70px badge', `badge-light-${log.state}`, 'me-4')}>
                        {log.code}
                      </span>

                      <a href='#' className='text-gray-800 text-hover-primary fw-bold'>
                        {log.message}
                      </a>

                      <span className='badge badge-light fs-8'>{log.time}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className='py-3 text-center border-top'>
                <Link
                  to='/crafted/pages/profile'
                  className='btn btn-color-gray-600 btn-active-color-primary'
                >
                  View All{' '}
                  <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                </Link>
              </div>
            </div> */}
          </div>
        </>
      )}
    </div>
  )
}

export {HeaderNotificationsMenu}
